import { styled } from '@mui/material/styles';
import { Box, Button } from '@mui/material';

// PassCard / TrialTicketCard 의 1-row 버튼 영역 스타일.
// 카드 외형/타이포 styled은 모두 CourseTicketCardStyled.js를 공유한다 — Figma 디자인 통일.

export const CardButtonArea = styled(Box, {
  shouldForwardProp: prop => prop !== 'isStopped',
})(({ isStopped }) => ({
  backgroundColor: isStopped ? '#d9d9d9' : '#fff',
  display: 'flex',
  flexDirection: 'row',
  borderRadius: 0,
}));

export const CardButton = styled(Button, {
  shouldForwardProp: prop =>
    prop !== 'isStopped' && prop !== 'noBorderRight' && prop !== 'noBorderLeft' && prop !== 'noBorderTop',
})(({ isStopped, noBorderRight, noBorderLeft, noBorderTop }) => ({
  flex: 1,
  border: isStopped ? '1px solid #fff' : '1px solid #d9d9d9',
  borderRadius: 0,
  padding: '8px 12px',
  fontSize: '12px',
  fontWeight: 500,
  color: isStopped ? '#262626' : '#262626',
  textTransform: 'none',
  letterSpacing: '-0.12px',
  minHeight: 'auto',
  ...(noBorderRight && { borderRight: 'none' }),
  ...(noBorderLeft && { borderLeft: 'none' }),
  ...(noBorderTop && { borderTop: 'none' }),
  '&:hover': {
    backgroundColor: isStopped ? 'transparent' : '#f5f5f5',
  },
  '&:disabled': {
    color: '#bdbdbd',
  },
}));
